import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';

interface ConfirmUpdateRestrictionsModal {
  open: boolean;
  onClose: () => void;
  submit: () => void;
}

/**
 * Default Component
 */
const ConfirmUpdateRestrictionsModal = (props: ConfirmUpdateRestrictionsModal) => {
  const { open, onClose, submit } = props;

  return (
    <Modal
      title="Update Required: Work Restrictions"
      open={open}
      onClose={onClose}
      scrollContainer="viewport"
      closeLabel="Close"
      aria-describedby="modal-description"
      width="600"
    >
      {/* Modal Body */}
      <Text id="modal-description">Please update this case's work restrictions using our new entry process.</Text>

      {/* Modal Footer */}
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="secondary" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" size="small" onClick={submit}>
            Update Restrictions
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmUpdateRestrictionsModal;
